import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Btn } from "../../../../AbstractElements";
import { AlertMode, WarningModeTitle } from "../../../../Constants/Constants";
import { WarningModeSubTitle } from "../../../../Data/BonusUi/SweetAlert";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const WarningMode = () => {
  const handleAlert = () => {
    Swal.fire({
      title: "Good job!",
      text: "You clicked the button!",
      icon: "warning",
    });
  };
  return (
    <Col xxl="3" lg="4" sm="6" xs="12">
      <Card className="height-equal">
        <CommonCardHeader title={WarningModeTitle} span={WarningModeSubTitle} />
        <CardBody className="btn-showcase">
          <Btn color="warning" className="sweet-6" onClick={handleAlert}>
            {AlertMode}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};
export default WarningMode;
